import React from "react";
import RequestPageMUI from "./RequestPageMUI";

const ParittaAtHome = () => {
  return (
    <RequestPageMUI
      title="Paritta at home Requests"
      fetchUrl="/get-paritta-at-home-requests"
      editEndpoint="edit-paritta-at-home-requests"
      deleteEndpoint="paritta-at-home-requests"
      statusEndpoint="edit-paritta-at-home-requests"
      dateFields={['date', 'created_at', 'updated_at']}
      hiddenFields={['ip_address']} // Hide IP address if present in your data
    />
  );
};

export default ParittaAtHome;